export const createResizeWindowHandler =
  (resizeWindow) =>
  (...args) => {
    resizeWindow(...args);
  };
